export const CAROUSEL_EPISODES_LIMIT = 10;

export const Modals = {
  ONBOARDING: 'ONBOARDING',
  BROWSER_AUTOPLAY_PROHIBITED: 'BROWSER_AUTOPLAY_PROHIBITED',
  CONCURRENT_SESSION_PROHIBITED: 'CONCURRENT_SESSION_PROHIBITED',
  LISTEN_REJECTED: 'LISTEN_REJECTED',
  REDEEM: 'REDEEM',
  CPE_DOWNLOAD_PROGRESS: 'CPE_DOWNLOAD_PROGRESS',
  CPA_SIGNUP: 'CPA_SIGNUP',
  CPA_CONTENT_END: 'CPA_CONTENT_END',
  TRACKER_ADD_EDIT: 'TRACKER_ADD_EDIT',
  TRACKER_DELETE: 'TRACKER_DELETE',
  SIGN_UP: 'SIGN_UP',
  EPISODE_EVALUATION: 'EPISODE_EVALUATION',
  EPISODE_FEEDBACK: 'EPISODE_FEEDBACK',
  PRODUCT_FEEDBACK: 'PRODUCT_FEEDBACK',
  APP_DOWNLOAD: 'APP_DOWNLOAD',
  APP_LOGIN_QR_CODE: 'APP_LOGIN_QR_CODE',
  CHAPTER_QUIZ: 'CHAPTER_QUIZ',
  MEMBER_ARCHIVE: 'MEMBER_ARCHIVE',
  NEW_TEAM: 'NEW_TEAM',
  UPGRADE_TEAM: 'UPGRADE_TEAM',
  SHARE_WITH_A_FRIEND: 'SHARE_WITH_A_FRIEND',
  SHARE_EPISODE: 'SHARE_EPISODE',
  KEEP_GOING_PROMO: 'KEEP_GOING_PROMO',
} as const;

export const TOAST_VARIANTS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export const NEW_FEATURE_ALERTS = {
  INVITE_MEMBERS_TOOLTIP: 'INVITE_MEMBERS_TOOLTIP',
  MEMBERS_NAV_ITEM_NEW_LABEL: 'MEMBERS_NAV_ITEM_NEW_LABEL',
  REPORTS_NAV_ITEM_NEW_LABEL: 'REPORTS_NAV_ITEM_NEW_LABEL',
  REPORTS_NAV_ITEM_NEW_CSV_LABEL: 'REPORTS_NAV_ITEM_NEW_CSV_LABEL',
  CONTENT_NAV_ITEM_NEW_LABEL: 'CONTENT_NAV_ITEM_NEW_LABEL',
  SHARE_EPISODE_MODAL: 'SHARE_EPISODE_MODAL',
  SHARE_EPISODE_MODAL_EMAIL: 'SHARE_EPISODE_MODAL_EMAIL',
  PROFILE_RECOVERY_EMAIL_PROMPT: 'PROFILE_RECOVERY_EMAIL_PROMPT',
  LIBRARY_FILTER_REGION: 'LIBRARY_FILTER_REGION',
  PINNED_LPS_CURATOR: 'PINNED_LPS_CURATOR',
  CONTENT_REGION_PREFERENCE: 'CONTENT_REGION_PREFERENCE',
} as const;
